import { useMemo } from 'react';
import * as R from 'ramda';
var useDimensionOptions = function useDimensionOptions(properties) {
  var dimensions = useMemo(function () {
    return R.pipe(R.pick(['scatterDimension', 'scatterX', 'scatterY', 'symbolDimension', 'stackedDimension']), R.toPairs)(properties);
  }, [properties]);
  return [dimensions];
};
export default useDimensionOptions;